import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { TestResultDto } from '../../shared/types/TestResultDto';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../shared/types/CarouselSettings';

@Component({
  selector: 'lp2-level-test-results-carousel',
  templateUrl: './level-test-results-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LevelTestResultsCarouselComponent {
  carouselSettings = {
    ...DEFAULT_CAROUSEL_SETTINGS, responsive: {
      0: {
        items: 2,
        slideBy: 1,
      },
      525: {
        items: 3,
        slideBy: 2,
      },
      992: {
        items: 5,
        slideBy: 3,
      },
      1200: {
        items: 6,
        slideBy: 4,
      },
    }
  } ;
  
  @Input() testResults: TestResultDto[];

  constructor() { }
}


// WEBPACK FOOTER //
// ./ts/app/test-results/level-test-results-carousel/level-test-results-carousel.component.ts